<template>

  <div>
    <div class="mainArea">
    <h1>Optionen</h1>

    <p>Erweitern Sie contexted.design schnell und unkompliziert anhand Ihrer Anforderungen.</p>

    <table class="dataTable">
        <tr>
          <th>Titel</th>
          <th>Beschreibung</th>
          <th></th>
        </tr>
        <tr>
          <td><b>SAP Data</b></td>
          <td>Laden Sie bequem Kennzahlen aus SAP.</td>
          <td>installiert</td>
        </tr>
        <tr>
          <td><b>Persona</b></td>
          <td>Pflegen Sie Ihre Persona's in contexted ein.</td>
          <td>installiert</td>
        </tr>
        <tr>
          <td><b>SWOT-Analyse</b></td>
          <td>Die Stärken-Schwächen-Analyse für contexted.</td>
          <td><button>installieren</button></td>
        </tr>
        <tr>
          <td><b>Jahresreport</b></td>
          <td>Integrieren Sie bequem Ihren Jahresreport.</td>
          <td><button>installieren</button></td>
        </tr>
        <tr>
          <td><b>CAD Viewer</b></td>
          <td>3D-Modelle im context verorten.</td>
          <td><button>installieren</button></td>
        </tr>
      </table>

    <br /><br />
    <button><svgicon icon="add" width="32" height="32" color="#000000"></svgicon> Eigenes Modul installieren</button>
    <br />
    <button class="btn--subtile" @click="signOut">Ausloggen</button>
    </div>
  </div>

</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'Options',
  methods: {
    signOut: function () {
      // Signout the user using firebase
      firebase.auth().signOut()
        .then(function (error) {
          if (error) {
            this.auth.user = firebase.auth().currentUser
            this.auth.message = 'User signed out Successfully'
          }
        }.bind(this), function (error) {
          if (error) {
            alert('Failed to signout user, try again later')
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Options.vue